// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-popup {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 10px 20px;
    border-radius: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
    animation: fade-in 0.3s ease;
  }
  
  .alert-success {
    background-color: #d1fae5;
    color: #047857;
  }
  
  .alert-error {
    background-color: #fee2e2;
    color: #b91c1c;
  }
  
  .alert-info {
    background-color: #bfdbfe;
    color: #1d4ed8;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: inherit;
    margin-left: 10px;
  }
  
  .close-btn:hover {
    color: #000;
  }
  
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/styles/alertmessage.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":[".alert-popup {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    padding: 10px 20px;\n    border-radius: 5px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 1000;\n    animation: fade-in 0.3s ease;\n  }\n  \n  .alert-success {\n    background-color: #d1fae5;\n    color: #047857;\n  }\n  \n  .alert-error {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n  \n  .alert-info {\n    background-color: #bfdbfe;\n    color: #1d4ed8;\n  }\n  \n  .close-btn {\n    background: none;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n    color: inherit;\n    margin-left: 10px;\n  }\n  \n  .close-btn:hover {\n    color: #000;\n  }\n  \n  @keyframes fade-in {\n    from {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
